import {
    ADD_ORDER_FAIL,
    ADD_ORDER_SUCCESS,
    DELETE_ORDER_FAIL,
    DELETE_ORDER_SUCCESS,
    DOWNLOAD_INVOICE_FAIL,
    DOWNLOAD_INVOICE_SUCCESS,
    EXPORT_ORDER_FAIL,
    EXPORT_ORDER_SUCCESS,
    GET_ORDER_DETAILS_FAIL,
    GET_ORDER_DETAILS_SUCCESS,
    GET_ORDER_LISTING_FAIL,
    GET_ORDER_LISTING_SUCCESS,
    INSERT_LOG_ORDER_FAIL,
    INSERT_LOG_ORDER_SUCCESS,
    MARK_AS_PAID_FAIL,
    MARK_AS_PAID_SUCCESS,
    MARK_AS_CLOSED_FAIL,
    MARK_AS_CLOSED_SUCCESS,
    RESET_ORDER_ATTACHMENT_STATE,
    RESET_ORDER_STATE,
    REVERT_ORDER_STATUS_FAIL,
    REVERT_ORDER_STATUS_SUCCESS,
    UPDATE_BILLING_DETAILS_FAIL,
    UPDATE_BILLING_DETAILS_SUCCESS,
    UPDATE_COURIER_FAIL,
    UPDATE_COURIER_SUCCESS,
    UPDATE_CUSTOMER_DETAILS_FAIL,
    UPDATE_CUSTOMER_DETAILS_SUCCESS,
    UPDATE_ORDER_FAIL,
    UPDATE_ORDER_SUCCESS,
    UPDATE_SHIPPING_DETAILS_FAIL,
    UPDATE_SHIPPING_DETAILS_SUCCESS,
    UPDATE_STATUS_FAIL,
    UPDATE_STATUS_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    orderListing: [],
    orderDetails: [],
    addOrder: [],
    updateOrder: [],
    deleteOrder: [],
    insertLogOrder: [],
    updateCustomerDetails: [],
    updateShippingDetails: [],
    updateBillingDetails: [],
    markOrderAsPaid: [],
    markOrderAsClosed: [],
    updateOrderStatus: [],
    updateOrderCourier: [],
    revertOrderStatus: [],
    invoiceDocument: [],
    exportOrder: [],
    error: [],
}

const Order = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ORDER_LISTING_SUCCESS:
            return {
                ...state,
                orderListing: action.payload
            }
        case GET_ORDER_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                orderDetails: action.payload
            }
        case GET_ORDER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_ORDER_SUCCESS:
            return {
                ...state,
                addOrder: action.payload
            }
        case ADD_ORDER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_ORDER_SUCCESS:
            return {
                ...state,
                updateOrder: action.payload
            }
        case UPDATE_ORDER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_ORDER_SUCCESS:
            return {
                ...state,
                deleteOrder: action.payload
            }
        case DELETE_ORDER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case INSERT_LOG_ORDER_SUCCESS:
            return {
                ...state,
                insertLogOrder: action.payload
            }
        case INSERT_LOG_ORDER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_CUSTOMER_DETAILS_SUCCESS:
            return {
                ...state,
                updateCustomerDetails: action.payload
            }
        case UPDATE_CUSTOMER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_SHIPPING_DETAILS_SUCCESS:
            return {
                ...state,
                updateShippingDetails: action.payload
            }
        case UPDATE_SHIPPING_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_BILLING_DETAILS_SUCCESS:
            return {
                ...state,
                updateBillingDetails: action.payload
            }
        case UPDATE_BILLING_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case MARK_AS_PAID_SUCCESS:
            return {
                ...state,
                markOrderAsPaid: action.payload
            }
        case MARK_AS_PAID_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case MARK_AS_CLOSED_SUCCESS:
            return {
                ...state,
                markOrderAsClosed: action.payload
            }
        case MARK_AS_CLOSED_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_STATUS_SUCCESS:
            return {
                ...state,
                updateOrderStatus: action.payload
            }
        case UPDATE_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_COURIER_SUCCESS:
            return {
                ...state,
                updateOrderCourier: action.payload
            }
        case UPDATE_COURIER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case REVERT_ORDER_STATUS_SUCCESS:
            return {
                ...state,
                revertOrderStatus: action.payload
            }
        case REVERT_ORDER_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DOWNLOAD_INVOICE_SUCCESS:
            return {
                ...state,
                invoiceDocument: action.payload
            }
        case DOWNLOAD_INVOICE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_ORDER_SUCCESS:
            return {
                ...state,
                exportOrder: action.payload
            }
        case EXPORT_ORDER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_ORDER_STATE:
            return {
                ...state,
                orderListing: [],
                orderDetails: [],
                addOrder: [],
                updateOrder: [],
                deleteOrder: [],
                exportOrder: [],
                insertLogOrder: [],
                updateCustomerDetails: [],
                updateShippingDetails: [],
                updateBillingDetails: [],
                markOrderAsPaid: [],
                markOrderAsClosed: [],
                updateOrderStatus: [],
                updateOrderCourier: [],
                revertOrderStatus: [],
                invoiceDocument: [],
                error: [],
            }
        case RESET_ORDER_ATTACHMENT_STATE:
            return {
                ...state,
                exportOrder: [],
                invoiceDocument: [],
                error: [],
            }
        default:
            return state
    }
}

export default Order
